/**
 * Для добавления горизонтального пустого пространства
 * @param props
 * @component
 * @category Component
 * @example
 * ```tsx
 * import {HSpace} from "ui/HSpace";
 *
 * function Example(){
 *     return (
 *         <>
 *             <div>
 *                 <span>ФИО:</span><HSpace/><span>Иванов Иван Иванович</span>
 *             </div>
 *
 *             <div>
 *                 <span>ФИО:</span><HSpace size={2}/><span>Петров Петр Петрович/span>
 *             </div>
 *
 *             <div>
 *                 <span>ФИО:</span><HSpace size="2rem"/><span>Васильев Василий Васильевич</span>
 *             </div>
 *         </>
 *     )
 * }
 * ```
 */
export function HSpace({
	size = "2rem",
}: {
	/**
	 * размер пространства. Если указано число, то будет использоваться ед. изм. `rem`
	 * @defaultValue '2rem'
	 */
	size?: string | number
}) {
	return (
		<div
			style={{
				width: typeof size === "number" ? `${size}rem` : size,
				display: "inline-block",
			}}
		></div>
	)
}
